module.exports = __webpack_public_path__ + "static/media/Linechart.08a7cdc3.svg";